// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_home_home_module_ts":"c39afb4d34dd6767","common":"b8f501bfa629b3d1","src_app_features_user-home_user-home_module_ts":"925089dc4c6fce08","src_app_features_manage-profile_manage-profile_module_ts":"ea11b7b6e47bd097"}[chunkId] + ".js";
};